// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailO":"O_wave2DetailO__Jh9W_"};